import { render, staticRenderFns } from "./CertificationForm.vue?vue&type=template&id=dc68e808&scoped=true"
import script from "./CertificationForm.vue?vue&type=script&lang=js"
export * from "./CertificationForm.vue?vue&type=script&lang=js"
import style0 from "./CertificationForm.vue?vue&type=style&index=0&id=dc68e808&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc68e808",
  null
  
)

export default component.exports